export default __webpack_public_path__ + "static/media/cloud-mobile.985bdc4e.svg";